import { Text } from "@chakra-ui/react";
import { Box, Flex } from "@chakra-ui/layout";
import { Empty } from "antd";
import { VotacaoParticipanteResponse } from "core/features/assembleia/typings";
import ListViewItem from "components/ListView/ListViewItem";

interface ListaParticipantesProps {
  participantes: VotacaoParticipanteResponse[] | undefined;
}

function ListaParticipantes({ participantes }: ListaParticipantesProps) {
  return (
    <Flex flexDir="column" gridGap={3}>
      <Box px={6} mt="16px" className="hidden-print">
        <Flex>
          <Flex flex={1}>
            <Text pl="50px" fontWeight="bold">
              Morador
            </Text>
          </Flex>
          <Flex>
            <Text fontWeight="bold">Peso</Text>
          </Flex>
        </Flex>
      </Box>

      {participantes?.map((participante, index) => {
        const u = participante.unidades
          .map((u) =>
            u.blocoQuadra ? `${u.numero} / Bloco ${u.blocoQuadra}` : u.numero
          )
          .join(", ");

        return (
          <ListViewItem
            key={index}
            title={participante.nome}
            right={`${participante.peso}`}
            description={`Unidade${
              participante.unidades.length > 1 ? "s" : ""
            }: ${u}`}
          />
        );
      })}

      {!participantes?.length ? (
        <Flex
          bg="white"
          justifyContent="center"
          alignItems="center"
          flex={1}
          py="32px"
        >
          <Empty />
        </Flex>
      ) : null}
    </Flex>
  );
}

export default ListaParticipantes;
